import $ from 'jquery';
import _ from 'underscore';
import { getStorage } from '../../../home24/helpers/storage-factory';
import * as baseTracking from '../../../home24-shared/core/base-tracking';
import { getCurrentDataLayer } from '../../../home24-shared/tracking/common/helper';

/**
 * tracking of success/failed registration
 */

var storage = getStorage();
var $el = $('body');
var $form;

const login = _.extend(
  {
    cookieCallbacks: {
      GtmOnLoginPageLoginSuccess: 'afterLogin'
    },

    init: function() {
      $form = $el.find('.js-login-form');
      $form.on('submit.loginEvents', _.bind(this.onLoginFormSubmit, this));
    },

    onLoginFormSubmit: function() {
      var validator = $form.validate();

      if (validator.valid()) {
        storage.set('GtmOnLoginPageLoginSuccess', 1);
      }
    },

    afterLogin: function() {
      // are we on next page after login?
      // check if no server side validation errors
      if (this.areServerSideErrors()) {
        this.onServerLoginFailed();
      } else {
        // all fine from the server
        this.onLoginSuccess();
      }
    },

    onLoginSuccess: function() {
      var data = getCurrentDataLayer();

      window.dataLayer.push({
        event: 'login',

        // female or male
        gender: data.visitorDemographicInfo
          ? data.visitorDemographicInfo.slice(0, 1)
          : '',
        customer_type: data.visitorAccountType
      });
    },

    getErrors: function() {
      return $el.find('.messages').find('.error');
    },

    areServerSideErrors: function() {
      return this.getErrors().length;
    },

    onServerLoginFailed: function() {
      var dataLayerObject = {
        event: 'log_failed'
      };

      // read server side errors
      dataLayerObject.err_text = this.getErrors()
        .map(function(index, element) {
          return {
            name: 'email_pw',
            message: $(element).text()
          };
        })
        .get();

      window.dataLayer.push(dataLayerObject);
    },

    destroy: function() {
      $form.off('.loginEvents');
    }
  },
  baseTracking
);

export function init() {
  return login.init();
}

export function executeCookieCallbacks() {
  return login.executeCookieCallbacks();
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/login/login.js
 **/